<template>
    <div class="contents">
        <div class="contents__contents contents__contents--result">
            <div class="contents__set">
                <p class="title">
                    내몸이 보내는<br>
                    단백질 부족 신호
                </p>
                <!--70 ~ 100 점 -->
                <div class="contents__card check-list">
                    <p class="check-list__msg check-list__msg--danger"><i></i> 위험해요! 단백질 꼭 챙겨드세요</p>
                    <ul class="check-list__list">

                        <li v-if="this.proteinSelfCheckList.includes('Q9-1')" class="check-list__item">
                            <i></i>
                            탈모 고민
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-2')" class="check-list__item">
                            <i></i>
                            가늘어진 머리카락
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-3')" class="check-list__item">
                            <i></i>
                            거칠고 푸석한 피부
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-4')" class="check-list__item">
                            <i></i>
                            손발톱 갈라짐
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-5')" class="check-list__item">
                            <i></i>
                            근육량 감소
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-6')" class="check-list__item">
                            <i></i>
                            면역력 감소
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-7')" class="check-list__item">
                            <i></i>
                            혈액순환 장애
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-8')" class="check-list__item">
                            <i></i>
                            단 음식이 자주 먹고 싶음
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-9')" class="check-list__item">
                            <i></i>
                            피로감
                        </li>

                        <li v-if="this.proteinSelfCheckList.includes('Q9-10')" class="check-list__item">
                            <i></i>
                            근력 감소
                        </li>
                    </ul>
                </div>
                <p class="contents__msg">위 증상들은 모두 단백질이 부족해질 때 우리 몸에서 보내는 신호들이에요.</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props : {
        proteinSelfScore : Number,
        proteinSelfCheckList : Array
    },
    mounted () {
    }
}

</script>

<style scoped>
@import "../assets/css/amway.css";
</style>


// WEBPACK FOOTER //
// src/views/myprotein-test/component/myproteinSelfHighScore.vue